import nextAction from 'model/actions/utilities/nextAction';

const placeholder = title => onDone => ({
  title,
  buttons: [nextAction('Dismiss', onDone)]
});

export default placeholder;
